<template>
  <div>
    <NavBar />
    <div class="mx-12 mt-2">
      <MainMenu />
      <notification-container />

      <v-progress-linear
        v-if="this.statisticsLoading"
        :indeterminate="true"
        :color="this.appThemeComponentsMainColor"
        value="100"
      ></v-progress-linear>
      <v-row>
        <v-col cols="6">
          <div class="mb-4">
            <documents-chart id="dashboard__estado_anual__char" type="statusYearly" />
          </div>
          <documents-chart id="dashboard__creados_anual__char" type="createdYearly" />
        </v-col>
        <v-col cols="6">
          <documents-chart id="dashboard__estado_mensual__char" type="statusMonthly" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { appThemeData } from '@/store/helpers'
import DocumentsChart from '../components/DocumentsChart'
import { documentsChartStoreData } from '../store/documentsChartStoreHelpers'

export default {
  name: 'DocumentsPage',
  components: {
    DocumentsChart
  },
  computed: {
    ...appThemeData,
    ...documentsChartStoreData
  }
}
</script>
